import createTexture from "gl-texture2d";

export const loadTexture = (image: any, gl: WebGLRenderingContext) => {
  const texture = createTexture(gl, image);
  texture.minFilter = gl.LINEAR;
  texture.magFilter = gl.LINEAR;
  return texture;
};
